export enum State {
	Loading = 'Loading',
	Idle = 'Idle',
	Done = 'Done',
	Failed = 'Failed'
}
